export default "__VITE_ASSET___$uMPRI__Y7tVr1bvVtHJg__"